
@if(lastAlert().message) {
<div class="fullscreen-alert {{lastAlert().color}}" (click)="dismiss()">
    <div class="close-button"><i class="fa fa-times"></i></div>
    <h1 class="fullscreen-alert-title" [style.fontSize]="lastAlert().fontSize || '24px'">{{lastAlert().message}}</h1>
</div>
}
@if(headerAlert().message) {
<p class="header-alert {{headerAlert().color}}"  (click)="dismissHeader()">{{headerAlert().message}}</p>
}